import React from 'react';
import { useSelector } from 'react-redux';
import styles from './Currency.module.scss';
import getSymbolFromCurrency from 'currency-symbol-map';
import Box from '@mui/material/Box';
import cn from 'classnames';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
export const Currency = ({ currency, destination }) => {
  const userStore = useSelector((state) => state.user.value);
  return (
    <Box
      sx={{
        width: '100%',
        filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.05))',
        backgroundColor: '#002F4A',
        padding: '1rem',
        textAlign: 'left',
        position: 'relative',
      }}
    >
      <div className={cn(styles.icon)}>
        <CurrencyExchangeIcon className="m-auto" />
      </div>
      <div className={cn(styles.currencyHeader, 'font-fragment')}>
        {destination.name} currency is {destination.currency}
        &nbsp;({getSymbolFromCurrency(destination.currency)})
      </div>
      <div className={cn(styles.currencyContent, 'font-libre')}>
        Current currency exchange rate is: <br />1 {userStore.currency} (
        {getSymbolFromCurrency(userStore.currency)}) ={' '}
        {currency.Rate.toFixed(3)} {destination.currency}(
        {getSymbolFromCurrency(destination.currency)})
        <br />1 {destination.currency} (
        {getSymbolFromCurrency(destination.currency)}) ={' '}
        {(1 / currency.Rate).toFixed(3)} {userStore.currency}(
        {getSymbolFromCurrency(userStore.currency)})
      </div>
    </Box>
  );
};
